import React from "react";
import {Box} from '@material-ui/core';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';
import setDate from "../../utils/setDate";
import theme from "../../styles/theme";
import convertToCurrency from "../../utils/convertToCurrency";

const LeadPurchaseRequestsSearchTable = () => {
    return [
        {
            id: 'status',
            title: 'Status',
            enabled: true,
            data: (leadPurchaseRequest) => (
                <>
                    {leadPurchaseRequest.result && (
                        <Box display="flex" alignItems="center">
                            {
                                leadPurchaseRequest.result.status === 'SOLD' ? (
                                    <AttachMoneyIcon style={{color: theme.palette.success.main}}/>
                                ) : (
                                    <MoneyOffIcon style={{color: theme.palette.error.main}}/>
                                )
                            }
                            <strong>- {leadPurchaseRequest.result.status}</strong>
                        </Box>
                    )}
                </>
            )
        },
        {
            id: 'affiliateStatus',
            title: 'Affiliate Status',
            enabled: true,
            data: (leadPurchaseRequest) => (
                <>
                    {leadPurchaseRequest.response ? leadPurchaseRequest.response.status : 'N/A'}
                </>
            )
        },
        {
            id: 'redirected',
            title: 'Redirected',
            enabled: true,
            data: (leadPurchaseRequest) => (
                <Box display="flex" justifyContent="center">
                    {leadPurchaseRequest.redirect && leadPurchaseRequest.redirect.length > 0 ? (
                        <PlayArrowIcon fontSize="large" style={{color: theme.palette.success.main}}/>
                    ) : (
                        <StopIcon fontSize="large" style={{color: theme.palette.error.main}}/>
                    )}
                </Box>
            )
        },
        {
            id: 'created',
            title: 'Created',
            enabled: true,
            data: (leadPurchaseRequest) => (
                <>
                    {setDate(leadPurchaseRequest.createdAt)}
                </>
            )
        },
        {
            id: 'primary-email',
            title: 'Primary Email',
            enabled: true,
            data: (leadPurchaseRequest) => (
                <>
                    {leadPurchaseRequest.primaryEmail}
                </>
            )
        },
        {
            id: 'affiliate',
            title: 'Affiliate',
            enabled: true,
            data: (leadPurchaseRequest) => (
                <>
                    {leadPurchaseRequest.trafficSource.affiliate.name}
                </>
            )
        },
        {
            id: 'traffic-source',
            title: 'Traffic Source',
            enabled: true,
            data: (leadPurchaseRequest) => (
                <>
                    {leadPurchaseRequest.trafficSource.name} ({leadPurchaseRequest.trafficSource.legacyPromoId})
                </>
            )
        },
        {
            id: 'min',
            title: 'Min',
            enabled: true,
            alignment: 'right',
            data: (leadPurchaseRequest) => (
                <>
                    {leadPurchaseRequest.minimumPrice !== null ? convertToCurrency(leadPurchaseRequest.minimumPrice) : 'N/A'}
                </>
            )
        },
        {
            id: 'billed',
            title: 'Billed',
            enabled: true,
            alignment: 'right',
            data: (leadPurchaseRequest) => (
                <>
                    {leadPurchaseRequest.result && leadPurchaseRequest.result.billed !== null ? convertToCurrency(leadPurchaseRequest.result.billed) : 'N/A'}
                </>
            )
        },
        {
            id: 'payout',
            title: 'Payout',
            enabled: true,
            alignment: 'right',
            data: (leadPurchaseRequest) => (
                <>
                    {leadPurchaseRequest.result && leadPurchaseRequest.result.payout !== null ? convertToCurrency(leadPurchaseRequest.result.payout) : 'N/A'}
                </>
            )
        }
    ];
};

export default LeadPurchaseRequestsSearchTable;
